import { render, staticRenderFns } from "./CustomerStatementsDetail.vue?vue&type=template&id=4715f4a6&scoped=true"
import script from "./CustomerStatementsDetail.vue?vue&type=script&lang=js"
export * from "./CustomerStatementsDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatementsDetail.vue?vue&type=style&index=0&id=4715f4a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715f4a6",
  null
  
)

export default component.exports